module.exports = fox._r("flash/flowplayer.commercial-3.2.16.swf", __webpack_public_path__ + "_/_/_/_/publisher/flash/flowplayer.commercial-3.2.16.swf");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/publisher/flash/flowplayer.commercial-3.2.16.swf
// module id = 449
// module chunks = 4